<template>
	<div
		class="btn offer"
		@click="selectThisBuyInOffer($event)"
		:class=" allBuyInOffersNotSelected ? '': buyInOfferSelected ? '' : 'buy-in-offer-not-selected'"
		:id="`offer-${buyInOffer.id}`"
	>
	<!-- <span v-if="buyInOfferSelected" @click="closeBuyInOffer()" style="color: #FFF !important;" class="text-font-15">&#10006;</span> -->
	 <span v-if="buyInOfferSelected" @click="closeBuyInOffer()" style="color: #FFF !important;" class="text-font-15">
		<div class="x-container">
			<div class="line"></div>
			<div class="line"></div>
		</div>
	 </span>
	
	
		<h1>{{ buyInOffer.publicName }}</h1>
		<div class="bold-text">
			<!-- <span class="multiplier-text" v-if="buyInOffer.playthroughMultiplier > 0">{{ languageStrings.buyInHasMultiplier }}</span> -->
			 <span class="multiplier-text" v-if="buyInOffer.creditPromoAUPerCashCOC > 0">
				<span class="italic-font">{{ languageStrings.receiveExclamation }} </span> 
				<span class="bonus-percent"> {{ bonusPercent }}%</span>
				<span class="italic-font">{{ languageStrings.bonusCredits }}</span> 
			</span>
			<p>
				<small>
					<span
						>{{ languageStrings.min }}:
						{{ systemFormatCurrency(buyInOffer.minimumCOC, systemCurrencyTool.displayType.minorOrFull) }} |
						{{ languageStrings.max }}:
						{{
							systemFormatCurrency(buyInOffer.maximumCOC, systemCurrencyTool.displayType.minorOrFull)
						}}</span
					>
				</small>
			</p>
		</div>
		<CommitBuyInOffer
			:buyInOfferSelected="buyInOfferSelected"
			:playerState="playerState"
			:buyInOffer="buyInOffer"
			:inGameCurrencyTool="inGameCurrencyTool"
			:systemCurrencyTool="systemCurrencyTool"
			:languageStrings="languageStrings"
			:languageErrorStrings="languageErrorStrings"
			:webPayOptions="webPayOptions"
			:isMobile="isMobile"
			:restrictedNeedsMoreInfo="restrictedNeedsMoreInfo"
			:hasBeenBlockedForBuyInAndCashOut="hasBeenBlockedForBuyInAndCashOut"
		/>
	</div>
</template>

<script>
import CurrencyTool from "@/dependencies/currencyTool";
import CommitBuyInOffer from "@/components/CommitBuyInOffer.vue";
import { onBeforeUnmount } from "vue";

export default {
	name: "BuyInOffer",
	inheritAttrs: false,
	props: {
		playerState: Object,
		buyInOffer: Object,
		// inGameCurrencyTool: Object,
		systemCurrencyTool: Object,
		languageStrings: Object,
		languageErrorStrings: Object,
		systemSettings: Object,
		webPayOptions: Object,
		inGameCurrencyInfo: Object,
		casinoList: Array,
		isMobile: Boolean,
		restrictedNeedsMoreInfo: Boolean,
		hasBeenBlockedForBuyInAndCashOut: Boolean
	},
	components: {
		CommitBuyInOffer,
	},
	data() {
		return {
			status: Object.assign({}, this.globalStatus),
			cashOutCurrency: this.buyInOffer.creditPromoAUPerCashCOC,
			// systemCurrencyInfo: this.buyInOffer.cashOutCurrency,
			buyInOfferSelected: false,
			inGameCurrencyTool: new CurrencyTool(this.inGameCurrencyInfo, this.localeString),
			buyInOfferClosed: false,
			allBuyInOffersNotSelected: true,
			buyInAmount: 0,
			promoCreditAmount:0,
			regularCreditAmount:0,
			bonusPercent: 0
		};
	},
	watch:{
		hasBeenBlockedForBuyInAndCashOut() {
			//console.log("there was a change to buy in offer", this.hasBeenBlockedForBuyInAndCashOut);
		}

	},
	created() {
		this.eventBus.on("nuveiCheckoutResult", () => {
			this.buyInOfferSelected = false;
		});
		this.eventBus.on("buyInAndPromoAmount", (buyInAndPromo)=> {
			this.buyInAmount = buyInAndPromo.fromPlayerCashCOC;
			this.promoCreditAmount = buyInAndPromo.potentialPromoCreditsEarned;
			this.regularCreditAmount = buyInAndPromo.regularCreditEarned;
		});
		this.eventBus.on("deselectBuyInOffer", (buyInId) => {
			// Deselects all buy-ins other than the id specified in the payload for this event.
			// Pass null in the payload for this event to deselect all buy-in offers.
			if (buyInId != this.buyInOffer.id) {
				this.allBuyInOffersNotSelected = false;
				this.buyInOfferSelected = false;
				var currentOffer = document.getElementById(`offer-${this.buyInOffer.id}`);
				currentOffer.classList.add("buy-in-offer-not-selected");
				
			}
			 else {
				this.allBuyInOffersNotSelected = false;
				this.buyInOfferSelected = true;
			}

			if(this.buyInOfferClosed) {
				this.buyInOfferSelected = false;
				this.allBuyInOffersNotSelected = true;
			}
		});
		this.eventBus.on("allBuyInOffersNotSelected", (buyInId) => {
			if(buyInId != this.buyInOffer.id){
				var currentOffer = document.getElementById(`offer-${this.buyInOffer.id}`);
				currentOffer.classList.contains("buy-in-offer-not-selected") ? currentOffer.classList.remove("buy-in-offer-not-selected") : '';
			}
		});

		this.bonusPercent = 100 *((this.buyInOffer.creditRegularAUPerCashCOC + this.buyInOffer.creditPromoAUPerCashCOC) / this.inGameCurrencyTool.currencyInfo.auPerCurrencyUnit ) - 100;

		onBeforeUnmount(() => {
			this.eventBus.off("nuveiCheckoutResult");
			this.eventBus.off("deselectBuyInOffer");
		});

	},
	methods: {
		selectThisBuyInOffer() {

			if(this.buyInOfferClosed) {
				this.buyInOfferSelected = false;
				this.buyInOfferClosed = false;
				return;
			}
			this.eventBus.emit("deselectBuyInOffer", this.buyInOffer.id);
			this.buyInOfferClosed = false;

		},
		systemFormatCurrency(valueCOC, display = {}) {
			return this.systemCurrencyTool.formatCurrency(valueCOC, display);
		},
		inGameFormatAUasCurrency(valueCOC, display = {}) {
			return this.inGameCurrencyTool.formatFromAU(valueCOC, display);
		},
		buyInCashString() {
			const compareFactor = this.systemCurrencyTool.currencyInfo.minorDigits < 1 ? 100 : 1;
			return this.systemCurrencyTool.formatCurrency(
				compareFactor,
				this.systemCurrencyTool.displayType.minorWholeOrFull
			);
		},
		closeBuyInOffer() {
			this.buyInOfferClosed = true;
			this.allBuyInOffersNotSelected = true;
			this.eventBus.emit("allBuyInOffersNotSelected", this.buyInOffer.id);
		
		},
		isOnlyPromoBonus() {
			return this.buyInOffer.creditRegularAUPerCashCOC == 0;
		},	
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
small {
	display: block;
	text-align: center;
}

h1 {
	line-height: 1.125em;
}
.flex-column {
	display: flex;
	flex-flow: column nowrap;
}

.buy-in-details {
	text-align: center;
	font-size: smaller;
}

p.flex-column {
	text-align: center;
}

.btn:hover {
	transform: none;
}

.offer {
	margin-bottom: 15px;
}

.buy-in-offer-not-selected {
		opacity: 0.2;
		max-height: 210px;
}

/* .arrow {
	border: solid black;
	border-width: 0 3px 3px 0;
	opacity: 100% !important;
} */

.text-font-15 {
	font-size: 15px;
	color: white !important;
}

.italic-font {
	font-style: italic;
}

.multiplier-text {
	font-size: 70%;
	display: flex;
	justify-content: center;
	align-items: center;
}

.bonus-percent {
	color: #F74D4D;
	font-weight: bolder;
	margin-left: 5px;
	margin-right:3px;
	font-size: 16px;
}
.x-container {
  position: relative; 
  width: 15px; 
  height: 15px; 
}

.line {
  position: absolute;
  width: 100%;
  height: 4px; 
  background-color: white;
  top: 50%;
  left: 0;
  transform-origin: center; 
}

.line:first-child {
  transform: translateY(-50%) rotate(45deg); 
}

.line:last-child {
  transform: translateY(-50%) rotate(-45deg);
}

@media (max-width: 768px) {
	.buyInOfferSelected {
		color: #fff;	
	}
}
</style>
